// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

// 转换es6代码兼容ie
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
// Vue.prototype.$fangfa = fangfa;
import fangfa from './components/tiaozhuan.js'
Vue.prototype.fangfa = fangfa;
// 仓库
import store from './store'

// 公共的样式
// import './theme/common.scss'
// import './style/css.css'
// import './style/style.css'
import './common/utils/MD.js'

import {Base64} from 'js-base64'
Vue.prototype.$Base64 = Base64;
Vue.use(Base64);

// import Vconsole from 'vconsole'
// new Vconsole()
// process.NODE_ENV === 'test' ? new Vconsole : ''

import './assets/fonts/iconfont.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.prototype.$bus = new Vue();

Vue.config.productionTip = false
Vue.use(ElementUI)

import Vant from 'vant';
import 'vant/lib/index.css';

Vue.use(Vant);

import cookies from 'js-cookie'
Vue.prototype.$cookies = cookies

// Vue.prototype.Swiper = Swiper;

import VueWordCloud from 'vue-wordcloud';
Vue.component('vue-wordcloud', VueWordCloud);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})

if(localStorage.getItem('orgId') == '3883'){
  document.title = '江汉区图书馆';
}

var routeList = [];
router.beforeEach((to, from, next) => {
  var index = -1;
  for(var i = 0; i < routeList.length; i++) {
    if(routeList[i].name == to.name) {
      index = i;
      break;
    }
  }
  if (index !== -1) {
//如果存在路由列表，则把之后的路由都删掉
    routeList.splice(index + 1, routeList.length - index - 1);
  } else if(to.name != '登录'){
    routeList.push({"name":to.name,"path":to.fullPath});
  }
  to.meta.routeList = routeList;
  next()
});



// WEBPACK FOOTER //
// ./src/main.js